import { elegant } from ".";

const ImgViewer = ({ pictures }) => {
  let gallery;

  gallery = pictures;
  gallery = elegant;
  return (
    <div style={{ paddingTop: 100, display: "grid", gridTemplateColumns: "repeat(5,1fr)" }}>
      {gallery.map((e, i) => {
        return (
          <div style={{ width: "100%", position: "relative" }}>
            <img
              src={e.big}
              alt={e.alt}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
            <p
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                background: "red",
                fontSize: 22,
                zIndex: 10,
              }}>
              {e.id ? e.id : i + 1}
              {e.cat && e.cat.map((f) => <span>{f}, </span>)}
            </p>
          </div>
        );
      })}
    </div>
  );
};
export default ImgViewer;
